export const camposLimposFormDependentes = {
    Nome: '',
    Telefone: '',
    CPF: '',
    Email: '',
    DepSexo: '',
    Categoria: '',
    Parentesco: '',
    Idade: null,
    Nascimento: null,
}